/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import {getResource} from "../../../selectors/generic";
import React from "react";
import {Checkbox} from "../forms/Checkbox";
import {useIsMobile} from "../../hoc/hooks";
import {isUserLoggedIn} from "../../../selectors/auth";
import {useSelector} from "react-redux";
import {ConditionalWrapper} from "../helper/ConditionalWrapper";

export const FrequentlyBoughtTogetherCell = ({product, fallbackImage, translate, changeSelection, selected, addEvent, position}) => {

    const isMobile = useIsMobile("1000px");
    const isLoggedIn = useSelector(isUserLoggedIn);

    return <>
        {isLoggedIn && <Checkbox id={product.materialNumber} key={"mobile-"+product.materialNumber}
                                 selected={selected} onChange={() => changeSelection(product.materialNumber)}
                                 list centered hideMobile={false} hideDesktop={true}/>}
        <React.Fragment key={"image"}>
            <ConditionalWrapper condition={product.productUrl}
                                wrapper={children => <a href={product.productUrl} onClick={() => addEvent(product, position)}
                                                        onMouseDown={(e) => e.button === 1 && addEvent(product, position)}>{children}</a>}>
                <div key={"image"} className={'p-minicart-product__image' + (!selected ? " unselected" : "")}>
                    <div className={'p-minicart-product__img'}
                         style={isMobile ? {backgroundImage : `url("${getResource(product.skuImageUrl || product.imageUrl || fallbackImage)}")`}
                             : {content: `url("${getResource(product.skuImageUrl || product.imageUrl || fallbackImage)}")`}}/>
                </div>
            </ConditionalWrapper>
        </React.Fragment>
        <div key={"name"} className="p-minicart-product-name">
            <div className={"p-minicart-product-checkbox-name-wrapper"}>
                {isLoggedIn && <Checkbox id={product.materialNumber} key={"desktop-"+product.materialNumber}
                                         selected={selected} onChange={() => changeSelection(product.materialNumber)}
                                         list centered hideMobile={true} hideDesktop={false}/>}
                {product.productUrl ?
                    <a href={product.productUrl} onClick={() => addEvent(product, position)}
                       onMouseDown={(e) => e.button === 1 && addEvent(product, position)}>{product.aemProdName}</a> :
                    <p>{product.aemProdName}</p>}
            </div>
            {isLoggedIn && <div className="p-minicart-product-price">
                {product.promotionUnitPriceDouble > 0 ?
                <div>
                    <span className="text-lt">{product.unitPrice}</span>
                    <p className={"promoted-value"}>{product.promotionUnitPrice}<span> {translate('each')}</span></p>
                </div> :
                <div>
                    <p>{product.unitPrice} <span> {translate('each')}</span></p>
                </div>}
            </div>}
        </div>
    </>
};
